import { UseInstallmentsListController } from "./types";

export const useInstallmentsListController = ({
  isFetching,
  installmentOptions,
  selectedInterestType,
  selectedInstallmentId,
  onInstallmentChange,
  onInterestTypeChange
}: UseInstallmentsListController) => {
  return {
    isFetching,
    installmentOptions,
    selectedInterestType,
    selectedInstallmentId,
    onInstallmentChange,
    onInterestTypeChange
  };
};
